import { actionTypes } from '../constants'

const initialState = {
  pageHeaderHeight: 0,
  pathname: null,
  search: null,
  windowIsOnUpswing: false,
  y: 0,
}

const app = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LAST_PROJECTS_URL_WAS_SET:
      return {
        ...state,
        pathname: action.payload.pathname,
        search: action.payload.search,
      }

    case actionTypes.PAGE_HEADER_HEIGHT_WAS_SET:
      return {
        ...state,
        pageHeaderHeight: action.payload.pageHeaderHeight,
      }

    case actionTypes.WINDOW_IS_ON_DOWNSWING:
      return {
        ...state,
        windowIsOnUpswing: false,
      }

    case actionTypes.WINDOW_IS_ON_UPSWING:
      return {
        ...state,
        windowIsOnUpswing: true,
      }

    case actionTypes.WINDOW_WAS_SCROLLED:
      return {
        ...state,
        y: action.payload.y,
      }

    default:
      return state
  }
}

export default app
